import { useEffect } from 'react';
import { withRouter, matchPath } from 'react-router-dom'; // eslint-disable-line
import localStorageFallback from 'local-storage-fallback';
import {
  setUserId,
  setEmployee,
  setAccess,
  setLastVisitedArtist,
  sendPageview,
  ga,
  sendEvent,
} from '@mrkt/features/Platform/googleAnalytics';
import {
  useCurrentUser,
  useIsEmployee,
} from '../../../../features/currentUser';

export const PageAnalytics = withRouter(function PageAnalytics({
  history,
  location,
}) {
  const currentUser = useCurrentUser();
  const isEmployee = useIsEmployee();
  const lastVisitedArtist = useLastVisitedArtist(location.pathname);
  const page = history.createHref(location);

  // set dimensions
  useEffect(() => {
    setUserId(
      (currentUser &&
        currentUser.partnerIds &&
        currentUser.partnerIds.google) ||
        '',
    );
    setEmployee(isEmployee);
    setAccess(currentUser ? currentUser.hasAccess : false);
    setLastVisitedArtist(lastVisitedArtist);
  }, [currentUser, isEmployee, lastVisitedArtist]);

  // set logged-in redirect dimension/event based on local storage item
  useEffect(() => {
    if (currentUser) {
      const loggedInRedirectKey = `${currentUser.username}:analytics:loggedInRedirect`;
      const loggedInRedirect = Boolean(
        localStorageFallback.getItem(loggedInRedirectKey),
      );
      if (loggedInRedirect) {
        ga('set', 'dimension8', 'Yes');
        sendEvent({
          eventCategory: 'Logged In Redirect',
          eventAction: 'Was Redirected',
          eventLabel: 'Yes',
        });
      }
      localStorageFallback.removeItem(loggedInRedirectKey);
    }
  }, [currentUser]);

  // send page view
  useEffect(() => {
    sendPageview(page);
  }, [page]);

  return null;
});

function useLastVisitedArtist(pathname = '/') {
  const currentUser = useCurrentUser();
  const username = currentUser ? currentUser.username : undefined;
  const key = `${username}:analytics:lastVisitedArtist`;

  let value = localStorageFallback.getItem(key) || '';

  const match = matchPath<{ artistId: string }>(pathname, {
    path: '/artist/:artistId',
  });

  if (match) {
    value = match.params.artistId;
  }

  useEffect(() => {
    if (!value) return;
    localStorageFallback.setItem(key, value);
  }, [key, value]);

  return value;
}
